import { ColumnType } from "antd/lib/table";
import moment from "moment";
import { useHistory } from "react-router";
import { DATETIME_FORMAT, EMPTY, IAP_PURCHASE_STATUS_MAP } from "constants/common";
import { InAppPurchaseRecordModel } from "types/model/customer";
import { Button } from "antd";

export const useColumnConfig = (): ColumnType<InAppPurchaseRecordModel>[] => {
  const history = useHistory();

  return [
    {
      title: "Product ISBN",
      dataIndex: "isbn",
      width: 110,
      ellipsis: true,
      render: (value, record) =>
        record.productId ? (
          <Button
            type="link"
            style={{ padding: 0, height: "auto" }}
            onClick={() => history.push(`/products/content/${record.productId}`)}
          >
            {value || EMPTY}
          </Button>
        ) : (
          value || EMPTY
        ),
    },
    {
      title: "Product name",
      dataIndex: "productName",
      width: 200,
      ellipsis: true,
      render: (value) => value || EMPTY,
    },
    {
      title: "Purchase type",
      dataIndex: "isSubscription",
      width: 100,
      ellipsis: true,
      render: (value: boolean) => (value ? "Subscription" : "Lifetime"),
    },
    {
      title: "Purchase status",
      dataIndex: "status",
      width: 110,
      ellipsis: true,
      render: (value) => IAP_PURCHASE_STATUS_MAP.get(value) || EMPTY,
    },
    {
      title: "Source",
      dataIndex: "source",
      width: 100,
      ellipsis: true,
      render: (value) => value || EMPTY,
    },
    {
      title: "Store event type",
      dataIndex: "notificationType",
      width: 110,
      ellipsis: true,
      render: (value) => value || EMPTY,
    },
    {
      title: "Total payment",
      dataIndex: "price",
      width: 110,
      ellipsis: true,
      render: (value) => (value ? value.currency + value.amount : EMPTY),
    },
    {
      title: "Transaction date",
      dataIndex: "transactionDateTime",
      ellipsis: true,
      width: 110,
      sortDirections: ["descend", "ascend", "descend"],
      sorter: true,
      render: (value) => (value ? moment(value).format(DATETIME_FORMAT) : EMPTY),
    },
    {
      title: "Expiration date",
      dataIndex: "expirationDate",
      ellipsis: true,
      width: 110,
      sortDirections: ["descend", "ascend", "descend"],
      sorter: true,
      render: (value) => (value ? moment(value).format(DATETIME_FORMAT) : EMPTY),
    },
    {
      title: "Created at",
      dataIndex: "createdDate",
      ellipsis: true,
      width: 110,
      defaultSortOrder: "descend",
      sortDirections: ["descend", "ascend", "descend"],
      sorter: true,
      render: (value) => (value ? moment(value).format(DATETIME_FORMAT) : EMPTY),
    },
  ];
};
